import { http, httpFile } from './http_service';

//Get all
export function all(){
    return http().get('/drivers-licence-type');
}
//Get all active
export function allActive(){
    return http().get('/drivers-licence-type/active');
}
//Get Single
export function single(id){
    return http().get(`/drivers-licence-type/${id}`);
}
//Add one
export function add(data){
    return http().post('/drivers-licence-type', data)
}
//Update
export function update(id, data){
    return http().put(`/drivers-licence-type/${id}`, data)
}
//Delete one
export function deleteSingle(id){
    return http().delete(`/drivers-licence-type/${id}`);
}